import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { GetCategoriesIcon, GetSportIcon } from 'assets/icons';
import { CategoryDataInterface } from '../../interface';
import NavigationItem from './navigationItem';

interface NavigationGroupProps {
	menu: {
		[key: number]: CategoryDataInterface[];
	}[];
	level: number;
	categoryId: number;
}

const NavigationGroup = ({ menu, level, categoryId }: NavigationGroupProps) => {
	if (!menu.length) return <></>;

	return (
		<>
			{/*eslint-disable-next-line @typescript-eslint/no-non-null-assertion*/}
			{menu?.[level]?.[categoryId]!.map((item: CategoryDataInterface, index: number) => {
				if (menu[level + 1]?.[item.categoryId]?.length) {
					return (
						<Accordion key={`${item.categoryId}-${index}`} className="navigation__accordion">
							<AccordionSummary className="navigation__accordion__summary" data-cy="left-tree-categories">
								{level === 0 ? (
									<GetSportIcon id={item.categoryId} className="navigation__icon" />
								) : (
									<GetCategoriesIcon category={item} className="navigation__icon" />
								)}
								{item.categoryName}
								<span className="navigation__count">{item.eventsCount}</span>
							</AccordionSummary>
							<AccordionDetails className="navigation__accordion__details">
								<NavigationGroup level={level + 1} menu={menu} categoryId={item.categoryId} />
							</AccordionDetails>
						</Accordion>
					);
				}

				return <NavigationItem key={`${item.categoryId}-${index}`} item={item} iconType="category" />;
			})}
		</>
	);
};

export default NavigationGroup;
